import { FilterInputType, FilterInputTemplate } from "@/app/home/components/filter/FilterBar";
import { ReportTableConfigs } from "@/app/home/components/report/ReportTable";
import { GlobalUtils } from "@/app/home/utils/global.utils";
import { TransactionExtraType } from "@/core/enums/global.enums";
import { TransactionModel } from "@/core/models/transaction.model";
import { formatCurrencyPipe } from "@/core/pipes/format-currency.pipe";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { transactionExtraTypePipe } from "@/core/pipes/transaction-extra-type.pipe";
import { TransactionRepo } from "@/core/repos/tables/transaction.repo";
import container from "@/lib/di/container";
import dayjs from "dayjs";

const transactionRepo = container.get(TransactionRepo);

export const TRANSACTION_REPORT_CONFIGS: {name: string, props: ReportTableConfigs<TransactionModel, null>} = {
    name: "Báo cáo Lịch sử giao dịch",
    props: {
        initialFilterMap: new Map(
            Object.entries({...GlobalUtils.getPreviousMonthFilter()})
        ),
        columns: [
            { dataIndex: 'beneficiaryName', name: 'Người thụ hưởng' },
            { dataIndex: 'amount', name: 'Số tiền giao dịch', pipe: formatCurrencyPipe },
            { dataIndex: 'currentBalance', name: 'Số dư hiện tại', pipe: formatCurrencyPipe },
            { dataIndex: 'extraType', name: 'Loại giao dịch', pipe: transactionExtraTypePipe},
            { dataIndex: 'createdAt', name: 'Thời gian giao dịch', pipe: formatDateTimePipe},
            { dataIndex: 'createdBy', name: 'Người tạo' },
            { dataIndex: 'information', name: 'Thông tin giao dịch' },
        ],
        filterTemplates:[
            {
                dataIndex: "search",
                label: "Tìm kiếm",
                placeholder: "Nhập nội dung tìm kiếm",
                type: FilterInputType.text,
            },
            {
                dataIndex: "extraType",
                label: "Loại giao dịch",
                placeholder: "Chọn Loại giao dịch",
                type: FilterInputType.select,
                options: Object.keys(TransactionExtraType).map(key => ({ value: key, name: transactionExtraTypePipe(key) }))
            },
            {
                rangeIndex: {from: "fromDate", to: "toDate"},
                type: FilterInputType.dateRange,
                placeholder: "Từ lúc",
                secondaryPlaceholder: "Đến lúc",
                label: "Thời gian giao dịch",
                span: 2,
                showTime: true
            }
        ],
        handleExport: async (filterMap) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const query: any = {};
            filterMap.forEach(filter => {
                if (filter.value) {
                    query[filter.key] = filter.value
                }
            })  
            const blobData = await transactionRepo.exportReport(query);
            if (blobData) {
                GlobalUtils.downloadXLSX(blobData, `LichSuGiaoDich-${dayjs().format("DDMMYYYY-hhmm")}`)
            };
        },
        init: async (filterTemplates) => {

            return {
                filterTemplates: filterTemplates
            }
        },
        onFilterChanged: async (map, changes, filterTemplates) => {
            let isDirty = false;
            const templates: FilterInputTemplate[] = [...filterTemplates];
            if (isDirty) {
                return {
                    filterTemplates: templates
                }
            };
            return {
                filterTemplates: undefined
            }
        },
        repository: transactionRepo
    }
}